import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactDetails = () => {
  const contactData = [
    {
      icon: <FaPhoneAlt size={26} />,
      title: "Contact Numbers",
      details: ["+91 9861934932", "+91 9776957641", "+91 7656081495"],
    },
    {
      icon: <FaEnvelope size={26} />,
      title: "Our Email Addresses",
      details: [
        "classeswebbocket@gmail.com",
        "web.bocket@gmail.com",
        "hr.webbocket@gmail.com",
      ],
    },
    {
      icon: <FaMapMarkerAlt size={26} />,
      title: "Our Location",
      details: [
        "Uco Bank Top Floor, Kolathia Square,",
        "Khandagiri, Bhubaneswar, Odisha",
        "Pin: 751030",
      ],
    },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white py-10 md:py-12">
      {/* Glow Orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-72 w-72 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Heading */}
        <div className="text-center mb-10" data-aos="fade-up">
          <p className="text-[10px] sm:text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-[#064585]">
            Contact Us
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2">
            Get in{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Touch
            </span>{" "}
            With Us
          </h2>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {contactData.map((item, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-lg rounded-2xl border border-[#5989C8]/15 shadow-md hover:shadow-lg transition-all duration-300 p-6 flex flex-col"
              data-aos="zoom-in"
            >
              {/* Icon */}
              <div className="flex items-center justify-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585] text-white shadow-md">
                  {item.icon}
                </div>

                {/* Title */}
                <h3 className="text-lg md:text-2xl font-semibold text-slate-800">
                  {item.title}
                </h3>
              </div>

              {/* Details */}
              {item.details.map((detail, idx) => (
                <p
                  key={idx}
                  className="text-slate-600 text-sm md:text-base font-light leading-relaxed"
                >
                  {detail}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
